@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.destinations

import com.narbase.letsgo.router.EndPoint


object GetPassengerDestinationsEndpoint :
    EndPoint<GetPassengerDestinationsEndpoint.Request, GetPassengerDestinationsEndpoint.Response>() {
    class Request(
        val searchTerm: String,
        val data: PassengerPointFilterDto,
    )

    class Response(
        val passengerDestinations: PassengerDestinationsDto,
    )
}